import { cn } from '@/lib/cn';

/**
 * Loading placeholder.
 *
 * `aria-hidden` because a screen reader announcing eight empty boxes is noise -
 * the containing region carries `aria-busy` and an `aria-live` status message
 * instead.
 */
export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>): JSX.Element {
  return <div aria-hidden className={cn('skeleton rounded', className)} {...props} />;
}
